/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"
import { ReturnItemsListBySO } from "../../types"

type UseReturnItemsListBySoProps = {
  params: {
    sales_order_id: string
  }
}

type Response = {
  payload: ReturnItemsListBySO[]
}

export function useReturnItemsListBySo({
  params
}: UseReturnItemsListBySoProps) {
  const api = useApi()
  const [data, setData] = useState<Response["payload"]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .post("return/byso", null, { params })
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? []
        setData(data)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    if (params.sales_order_id) {
      fetchData()
    }

    return () => {
      setData([])
      setLoading(false)
    }
  }, [params.sales_order_id])

  return {
    data,
    isLoading,
    refetch,
    dropdown: data.map((item) => ({
      value: item.return_id,
      label: item.trx_code
    }))
  }
}
